import React from 'react';
import { useStyles } from 'components/Statistics/styles';

import StatisticsDownloadButton from 'components/Button/StatisticsDownloadButton';

import { CartesianGrid, Line, LineChart, Tooltip, XAxis, YAxis } from 'recharts';

import _ from 'lodash';
import { CHART_COLORS, CHART_HEIGHT, CHART_WIDTH } from './Statistics';
import { MenuItem, Select } from '@material-ui/core';
import { DownloadType, TaskType } from 'commons/vo/param/StatisticsParamVO';
import { ExportTaskType } from 'commons/vo/param/StatisticsExportParamVO';
import { formatNumberWithComma, formatTooltipLabel } from './utils';

type DownloadProps = {
  statisticsDownloadData: LineChartData[];
  downloadType: DownloadType;
  startDate: string;
  endDate: string;
  onChangeDownloadType: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

function Download({
  statisticsDownloadData,
  downloadType,
  startDate,
  endDate,
  onChangeDownloadType,
}: DownloadProps) {
  const classes = useStyles();

  return (
    <div className={classes.section}>
      <div className={classes.sectionTitleBox}>
        <div className={classes.sectionTitle}>다운로드</div>

        <div className={classes.selectAndDownloadButton}>
          <div>
            <Select value={downloadType} onChange={onChangeDownloadType}>
              <MenuItem value={TaskType.Download}>총합</MenuItem>
              <MenuItem value={TaskType.DownloadFull}>전체 영상</MenuItem>
              <MenuItem value={TaskType.DownloadPartial}>부분 인출</MenuItem>
              <MenuItem value={TaskType.DownloadInterview}>인터뷰</MenuItem>
              <MenuItem value={TaskType.DownloadHighlight}>하이라이트</MenuItem>
            </Select>
          </div>
          <StatisticsDownloadButton
            taskType={ExportTaskType.Download}
            startDate={startDate}
            endDate={endDate}
          />
        </div>
      </div>

      <div className={classes.sectionBody}>
        <LineChart
          width={CHART_WIDTH}
          height={CHART_HEIGHT}
          data={statisticsDownloadData}
          margin={{ top: 30, bottom: 5, left: 25, right: 25 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis label={{ value: '횟수', position: 'top', offset: 15 }} width={20} />
          <Tooltip
            labelFormatter={value => {
              return [formatTooltipLabel(value)];
            }}
            formatter={value => {
              let key = '';
              switch (downloadType) {
                case TaskType.Download:
                  key = '총합 다운로드';
                  break;
                case TaskType.DownloadFull:
                  key = '전체 영상 다운로드';
                  break;
                case TaskType.DownloadPartial:
                  key = '부분 인출 다운로드';
                  break;
                case TaskType.DownloadInterview:
                  key = '인터뷰 다운로드';
                  break;
                case TaskType.DownloadHighlight:
                  key = '하이라이트 다운로드';
                  break;
                default:
                  key = '총합 다운로드';
                  break;
              }

              return [`${formatNumberWithComma(value)}회`, key];
            }}
          />
          <Line dataKey="value" stroke={CHART_COLORS.default} isAnimationActive={false} />
        </LineChart>
      </div>
    </div>
  );
}

export default Download;
